<template xmlns:v-data-table="http://www.w3.org/1999/html">
  <table-layout>
    <template v-slot:title>목록(총 {{ data.length }}건)</template>
    <template v-slot:button>
      <v-btn class="excel button" outlined @click="toExcel" :disabled="data.length < 1">
        엑셀다운로드
      </v-btn>
    </template>
    <template v-slot:table>
      <v-data-table
        :headers="getHeader(headers)"
        :items="data"
        :items-per-page="-1"
        :loading="loading"
        item-key="index"
        height="55vh"
        fixed-header
        no-data-text="조회된 데이터가 없습니다"
      >
        <template v-slot:item.createDate="{ value }">
          <div>{{ setDate(value) }}</div>
        </template>
      </v-data-table>
    </template>
  </table-layout>
</template>
<script>
import TableLayout from "@/common/layout/TableLayout.vue";
import TableMixin from "@/mixin/TableMixin";
import {SERVICE_LOG_TABLE} from "@/util/TableHeaders";
import _ from "lodash";
import func from "@/util/func";

export default {
  name: "ServiceLogTable",
  components: {TableLayout},
  props: ["data", "loading"],
  mixins: [TableMixin],
  data() {
    return {
      headers: SERVICE_LOG_TABLE
    }
  },
  methods: {
    toExcel() {
      // 리스트 빈 값 체크
      if(_.isEmpty(this.data)) return;
      const data = _.cloneDeep(this.data);
      const returnData = [];
      const now = func.getToday();

      // 엑셀 다운로드
      for (const item of data) {
        const obj = {
          "조직명": item["orgNm"],
          "사용자명": item["memberNm"],
          "아이디(사번)": item["id"],
          "IP": item["ip"],
          "구분": item["apiNm"],
          "처리일": this.setDate(item["createDate"])
        }
        returnData.push(obj);
      }
      const sheetName = `${now.replaceAll("-", "")}`;
      const fileName = `서비스 로그_${now.replaceAll("-", "")}`;
      func.extractExcelFile(returnData, sheetName, fileName);
    }
  }
}
</script>